import { validateEnv } from '../../utils/env.util';
import { getDeviceId } from '../../utils/device-id.util';

type EmployeeSessionAuditData = Record<string, unknown>;

const { VITE_BACKEND_LOCATION } = validateEnv();

export function logEmployeeSessionAudit(action: string, data: EmployeeSessionAuditData = {}): void {
  try {
    if (process.env.NODE_ENV === 'test') {
      return;
    }
    const token = process.env.REACT_APP_CLIENT_LOG_TOKEN;
    const route = typeof window === 'undefined' ? null : `${window.location.pathname}${window.location.hash}`;
    void fetch(`${VITE_BACKEND_LOCATION}/client-logs`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'content-type': 'application/json',
        ...(token ? { 'x-client-log-token': token } : {}),
      },
      body: JSON.stringify({
        scope: 'employee-session-audit',
        level: 'warn',
        message: action,
        data: { deviceId: getDeviceId(), route, ...data },
      }),
    }).catch(() => undefined);
  } catch {
    // Session diagnostics must never change login or logout behavior.
  }
}

export function employeeSessionFingerprint(sessionId: string | null | undefined): string | null {
  return typeof sessionId === 'string' && sessionId.length > 0 ? sessionId.slice(0, 8) : null;
}